import { Tooltip } from '@mantine/core'

import {
  formatDateTimeForTooltip,
  formatSmsTimestamp,
} from 'src/lib/formatters'

/**
 * Shared activity-log timestamp — smart-relative label (`Today 2:45 PM`,
 * `Yesterday`, `MMM D`, `MMM D, YYYY`) with the exact date on hover. Used by
 * every activity bubble (SMS, Call, …) so they read identically.
 */
const ActivityTimestamp = ({ date }: { date: string | Date }) => (
  <Tooltip label={formatDateTimeForTooltip(date)} position="top">
    <div className="text-[11px] text-doubleNickel-gray-400">
      {formatSmsTimestamp(date)}
    </div>
  </Tooltip>
)

export default ActivityTimestamp
